import { FC } from "react"

export const RouteMarker: FC<{ color: string; orderSequence: number }> = ({
  color,
  orderSequence,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="55"
    viewBox="0 0 48 63.5"
  >
    <path
      d="M24 0C10.7 0 0 10.7 0 24c0 17.6 20.1 36.6 22.4 38.7a2 2 0 0 0 3.2 0C27.9 60.6 48 41.6 48 24 48 10.7 37.3 0 24 0z"
      fill={color}
    />
    <circle cx="24" cy="24" r="16" fill="#ffffff" />
    <text
      x="24"
      y="30"
      textAnchor="middle"
      fontSize="16"
      fontFamily="Inter, Arial, sans-serif"
      fill="#000000"
      fontWeight="600"
    >
      {orderSequence}
    </text>
  </svg>
)
